import { render } from "./OrderCostBreakdown.vue?vue&type=template&id=03b0c668"
import script from "./OrderCostBreakdown.vue?vue&type=script&lang=js"
export * from "./OrderCostBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__